// THE TILE WHOSE READING WAS NEVER DESIGNED, AND WHAT IT SAYS INSTEAD.
//
// Roadmap line 1's own ruling: an AstrologyAPI endpoint whose input form has not been built is
// flagged `comingSoon` rather than guessed at, and this modal is the whole of what a member meets
// when she taps one. It is the only surface on the astrology page that says a reading is not here
// yet, and it must never read as a fault — so it names the three doors that ARE open beside it.
//
// Extracted by HER DASHBOARD ITEM's first surface (2026-08-13) to pay App.tsx's R8 ceiling as that
// round went, which is that ledger's own rule: a round that adds a capability pays for it in the
// same commit. **MOVED VERBATIM — no member-visible line changed**, so the round's render risk is
// carried by the build, the typecheck and the gate rather than by a claim.
//
// It renders `ModalBackdrop`, which holds two effects, so it is NOT one of the hookless leaves a
// gate CALLS (R7); it is the stateful class `SignInModal` and `TierCards` already moved as, and the
// reach it buys is the IMPORT rather than the render.
import type { AstrologyTool } from "../catalogs/astrology-menu";
import { ModalBackdrop } from "./ModalBackdrop";
import { useEscapeKey } from "./useEscapeKey";

export function ComingSoonModal({ tool, onClose }: { tool: AstrologyTool; onClose: () => void }) {
  useEscapeKey(onClose);
  return (
    <ModalBackdrop label={`${tool.title}`} onClose={onClose}>
      <div className="reading-modal coming-soon-modal">
        <button className="modal-close" type="button" onClick={onClose} aria-label="Close">x</button>
        <p className="eyebrow">Coming soon</p>
        <h2>{tool.title}</h2>
        <p>{tool.text}</p>
        <p className="coming-soon-modal__note">
          This reading is on the way. While it is being built, try the birth chart, the
          predictions, or the deeper readings on this page, or ask Lala anything on your mind.
        </p>
      </div>
    </ModalBackdrop>
  );
}
